export enum QuoteType {
  Quote = 'quote',
  Estimate = 'estimate',
  OrderConfirmation = 'orderConfirmation',
}
